import React, {Component} from "react";
import {Layout, Radio, Table, Modal, Form, Input, Pagination, Button, Select, message, Switch} from 'antd';

import Header from '../../components/header'
import Left from '../../components/leftAd'

import './grade.less'
import '../../assets/css/admin.less'
import {
    reqAddClass,
    reqClassList,
    reqDepartmentList,
    reqEditClass,
    reqGradeList,
    reqSpecialtyList
} from "../../api";

const {Content} = Layout;
const {Option} = Select;

/**
 * 班级管理路由组件
 */
class Grade extends Component {

    state = {
        total: 0,
        page: 1,
        size: 10,
        did: 1,
        classList: [],
        aClass: {},
        specialtyList: [],
        gradeList: [],
        departmentList: [],
        selectSpecialty: 0,
        selectGrade: 0,
        selectStatus: 0,
        selectDepartment: 0,
        ModalText: '',
        visible: false,
        name: '',
        specialtyName: '',
        departmentName: '',
        gradeName: '',
        selectedRowKeys: [],
        confirmLoading: false,
        setRecord:{},
        setVisible:false
    };

    selectSpecialtyChange = e => {
        this.setState({
            selectSpecialty: e,
        })
    };

    selectGradeChange = e => {
        this.setState({
            selectGrade: e
        })
    };

    selectStatusChange = e => {
        this.setState({
            selectStatus: e
        })
    };

    selectDepartmentChange = e => {
        this.setState({
            selectDepartment: e
        })
    };

    getClassList = async (data) => {
        const result = await reqClassList(data);
        if (result.code === '000000') {
            this.setState({
                classList: result.data.rows,
                total: result.data.total,
                page: result.data.page
            })
        } else {
            message.error(result.msg);
        }
    };

    getSpecialtyList = async (data) => {
        const result = await reqSpecialtyList(data);
        if (result.code === '000000') {
            this.setState({
                specialtyList: result.data.rows,
            })
        } else {
            message.error(result.msg);
        }
    };

    getGradeList = async (data) => {
        const result = await reqGradeList(data);
        if (result.code === '000000') {
            this.setState({
                gradeList: result.data.rows,
            })
        } else {
            message.error(result.msg);
        }
    };

    getDepartmentList = async (data) => {
        const result = await reqDepartmentList(data);
        if (result.code === '000000') {
            this.setState({
                departmentList: result.data.rows,
            })
        } else {
            message.error(result.msg);
        }
    };

    searchList = async () => {
        let data = {
            page: 1,
            size: 10
        };
        if (this.state.selectSpecialty !== '' && this.state.selectSpecialty !== 0) {
            data["specialtyId"] = this.state.selectSpecialty;
        }
        if (this.state.selectGrade !== '' && this.state.selectGrade !== 0) {
            data["gradeId"] = this.state.selectGrade;
        }
        if (this.state.selectStatus !== '' && this.state.selectStatus !== 0) {
            data["status"] = this.state.selectStatus;
        }
        this.getClassList(data);
    };

    clearSearch = () => {
        sessionStorage.clear();
        window.location.reload();
    };

    pageClick = async page => {
        let data = {
            page: page,
            size: 10
        };
        if (this.state.selectSpecialty !== '' && this.state.selectSpecialty !== 0) {
            data["specialtyId"] = this.state.selectSpecialty;
        }
        if (this.state.selectGrade !== '' && this.state.selectGrade !== 0) {
            data["gradeId"] = this.state.selectGrade;
        }
        if (this.state.selectStatus !== '' && this.state.selectStatus !== 0) {
            data["status"] = this.state.selectStatus;
        }
        this.getClassList(data);
    };

    itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a>上一页</a>;
        }
        if (type === 'next') {
            return <a>下一页</a>;
        }
        return originalElement;
    };

    showTotal = (total) => {
        return '共' + total + '条记录/每页' + this.state.size + '条';
    };

    showEditModal = (record) => {
        const aClass = {
            id: record.id,
            name: record.name,
            gradeName: record.gradeName,
            departmentName: record.departmentName,
            specialtyName: record.specialtyName,
            status: record.status.toString(),
            gradeId: record.gradeId,
            specialtyId: record.specialtyId,
            departmentId: record.departmentId
        };

        this.setState({
            visible: true,
            ModalText: '编辑班级信息',
            aClass: aClass
        });
    };

    showAddModal = () => {
        this.setState({
            visible: true,
            ModalText: '添加班级',
            aClass: {},
        });
    };

    showSetModal = (record) =>{
        const setRecord = {
            id: record.id,
            name: record.name,
            gradeName: record.gradeName,
            departmentName: record.departmentName,
            specialtyName: record.specialtyName,
            status: record.status,
            gradeId: record.gradeId,
            specialtyId: record.specialtyId,
            departmentId: record.departmentId
        };
        this.setState({
            setRecord : setRecord,
            setVisible : true
        })
    };

    handleOk = (event) => {
        //组织表单的默认行为
        event.preventDefault();
        //对所有表单字段进行校验
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                if(values.departmentName.indexOf("|") !== -1){
                    let arrDepartment = values.departmentName.split("|");
                    values["did"] = arrDepartment[0];
                    values["departmentName"] = arrDepartment[1];
                }
                if(values.specialtyName.indexOf("|") !== -1) {
                    let arrSpecialty = values.specialtyName.split("|");
                    values["sid"] = arrSpecialty[0];
                    values["specialtyName"] = arrSpecialty[1];
                }
                if(values.gradeName.indexOf("|") !== -1) {
                    let arrGrade = values.gradeName.split("|");
                    values["gradeId"] = arrGrade[0];
                    values["gradeName"] = arrGrade[1];
                }
                if (this.state.ModalText === '添加班级') {
                    let data = new FormData();
                    data.append("did", values['did']);
                    data.append("sid", values['sid']);
                    data.append("gradeId", values['gradeId']);
                    data.append("name", values['name']);
                    data.append("status", true);
                    const result = await reqAddClass(data);
                    if (result.code === '000000') {
                        message.success("添加成功");
                        this.searchList();
                        this.handleCancel();
                    } else {
                        message.error(result.data.msg);
                    }
                } else {
                    let data = new FormData();
                    data.append("did", values["did"]);
                    data.append("sid", values["sid"]);
                    data.append("gradeId", values['gradeId']);
                    data.append("name", values['name']);
                    data.append("status", values['status']);
                    const result = await reqEditClass(values.id, data);
                    if (result.code === '000000') {
                        this.searchList();
                        this.handleCancel();
                        message.success("修改成功");
                    } else {
                        message.error(result.data.msg);
                    }
                }
            }
        });

    };

    handleCancel = () => {
        this.setState({
            visible: false,
            deleteVisible: false,
            deleteId: '',
            deleteName: '',
            selectedRowKeys: [],
            setRecord:{},
            setVisible:false
        });
    };

    setClass=async(record)=> {
        let data = new FormData();
        if(record.status){
            data.append("status", false);
        }else {
            data.append("status", true);
        }
        data.append("did", record.departmentId);
        data.append("sid", record.specialtyId);
        data.append("gradeId", record.gradeId);
        data.append("name", record.name);
        const result = await reqEditClass(record.id, data);
        if (result.code === '000000') {
            message.success("修改成功");
            this.searchList();
        } else {
            message.error(result.data.msg);
        }
        this.handleCancel();
    };

    componentDidMount = async () => {
        this.getClassList({
            page: 1,
            size: 10
        });
        this.getSpecialtyList({
            page: 1,
            size: 100,
        });
        this.getGradeList({
            page: 1,
            size: 100,
        });
        this.getDepartmentList({
            page: 1,
            size: 100,
        });
        document.getElementsByClassName("ant-menu-item")[1].click();
    };

    render() {

        const {getFieldDecorator} = this.props.form;

        const {total, page, size, selectedRowKeys, confirmLoading, departmentList, classList, specialtyList, gradeList, ModalText, visible,setRecord,setVisible} = this.state;

        const columns = [
            {
                title: '编号',
                dataIndex: 'id',
                key: 'id',
                render: (text, record,index) => (
                    <span>{(this.state.page-1)*this.state.size+index+1}</span>
                ),
            },
            {
                title: '院/系',
                dataIndex: 'departmentName',
                key: 'departmentName',
            },
            {
                title: '专业',
                dataIndex: 'specialtyName',
                key: 'specialtyName',
            },
            {
                title: '年级',
                dataIndex: 'gradeName',
                key: 'gradeName',
            },
            {
                title: '班级名称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '学生人数',
                dataIndex: 'studentCnt',
                key: 'studentCnt',
            },
            {
                title: '班级状态',
                dataIndex: 'status',
                key: 'status',
                render: (text, record) => (
                    <span>
                        <Switch checked={record.status} onChange={this.showSetModal.bind(this,record)} checkedChildren="启用" unCheckedChildren="禁用" defaultChecked/>
                </span>
                ),
            },
            {
                title: '操作',
                key: 'action',
                render: (text, record) => (
                    <span>
                    <a onClick={this.showEditModal.bind(this, record)}>编辑</a>
                </span>
                ),
            },
        ];

        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                let name = [];
                for (let i = 0; i < selectedRows.length; i++) {
                    name.push(selectedRows[i].name)
                }
                this.setState({
                    deleteId: selectedRowKeys.toString(),
                    deleteName: name.toString(),
                    selectedRowKeys: selectedRowKeys
                })
            },
            getCheckboxProps: record => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
                name: record.name,
            }),
        };

        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <Left>Left</Left>
                    <Content>
                        <div className='table_right grade'>
                            <div className='table_search'>
                                <Button className='batch_delete ' onClick={this.showAddModal}>新建班级</Button>
                                <Button className='batch_delete clear' onClick={this.clearSearch.bind(this)}>重置</Button>
                                <Button className='batch_delete search' onClick={this.searchList.bind(this)}>检索</Button>
                                <div className='search_box'>
                                    <label>班级状态：</label>
                                    <Select id='search_select'
                                            showSearch
                                            style={{width: 170}}
                                            optionFilterProp="children"
                                            onChange={this.selectStatusChange.bind(this)}
                                            filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }>
                                        <Option key={0} value=''>全部</Option>
                                        <Option key={1} value='true'>正常</Option>
                                        <Option key={2} value='false'>禁用</Option>
                                    </Select>
                                </div>
                                <div className='search_box'>
                                    <label>年级：</label>
                                    <Select id='grade_select'
                                            style={{width: 170}}
                                            onChange={this.selectGradeChange.bind(this)}>
                                        <Option key={0} value={0}>全部</Option>
                                        {
                                            gradeList&&gradeList.map((item, index) => (
                                                <Option key={index} value={item.id}>{item.name}</Option>
                                            ))
                                        }
                                    </Select>
                                </div>
                                <div className='search_box'>
                                    <label>专业：</label>
                                    <Select id='grade_select'
                                            style={{width: 170}}
                                            onChange={this.selectSpecialtyChange.bind(this)}>
                                        <Option key={0} value={0}>全部</Option>
                                        {
                                            specialtyList&&specialtyList.map((item, index) => (
                                                <Option key={index} value={item.id}>{item.name}</Option>
                                            ))
                                        }
                                    </Select>
                                </div>
                            </div>
                            <Table columns={columns} pagination={false}
                                   dataSource={classList} rowKey={classList => classList.id}/>
                            <Pagination total={total} current={page} pageSize={size} onChange={this.pageClick}
                                        itemRender={this.itemRender} showTotal={this.showTotal}/>
                        </div>
                        <Modal className='grade_modal' title={ModalText} visible={visible} onOk={this.handleOk}
                               confirmLoading={confirmLoading} onCancel={this.handleCancel}
                               okText="确认" cancelText="取消" destroyOnClose='true'>
                            <Form>
                                <Form.Item hidden>
                                    {getFieldDecorator('id', {
                                        initialValue: this.state.aClass.id,
                                    })(<Input hidden/>)}
                                </Form.Item>
                                <Form.Item hidden>
                                    {getFieldDecorator('did', {
                                        initialValue: this.state.aClass.departmentId,
                                    })(<Input hidden/>)}
                                </Form.Item>
                                <Form.Item hidden>
                                    {getFieldDecorator('status', {
                                        initialValue: this.state.aClass.status,
                                    })(<Input hidden/>)}
                                </Form.Item>
                                <Form.Item label='院/系'>
                                    {getFieldDecorator('departmentName', {
                                        rules: [{required: true, message: '请输入院/系名称!'}],
                                        initialValue: this.state.aClass.departmentName
                                    })(
                                        <Select id='grade_select'
                                                style={{width: 200}}
                                                placeholder='请选择院/系'>
                                            <Option key={0} value={0}>全部</Option>
                                            {
                                                departmentList&&departmentList.map((item, index) => (
                                                    <Option key={index} value={item.id+"|"+item.name}>{item.name}</Option>
                                                ))
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                                <Form.Item hidden>
                                    {getFieldDecorator('sid', {
                                        initialValue: this.state.aClass.specialtyId,
                                    })(<Input hidden/>)}
                                </Form.Item>
                                <Form.Item label='专业'>
                                    {getFieldDecorator('specialtyName', {
                                        rules: [{required: true, message: '请输入专业名称!'}],
                                        initialValue: this.state.aClass.specialtyName
                                    })(
                                        <Select id='grade_select'
                                                style={{width: 200}}
                                                placeholder='请选择专业'>
                                            <Option key={0} value={0}>全部</Option>
                                            {
                                                specialtyList&&specialtyList.map((item, index) => (
                                                    <Option key={index} value={item.id+"|"+item.name}>{item.name}</Option>
                                                ))
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                                <Form.Item hidden>
                                    {getFieldDecorator('gradeId', {
                                        initialValue: this.state.aClass.gradeId,
                                    })(<Input hidden/>)}
                                </Form.Item>
                                <Form.Item label='年级'>
                                    {getFieldDecorator('gradeName', {
                                        rules: [{required: true, message: '请输入年级名称!'}],
                                        initialValue: this.state.aClass.gradeName
                                    })(
                                        ModalText === "添加班级"?
                                        <Select style={{width: 200}}
                                                placeholder='请选择年级'>

                                            <Option key={0} value=''>全部</Option>
                                            {
                                                gradeList&&gradeList.map((item, index) => (
                                                    <Option key={index} value={item.id+"|"+item.name}>{item.name}</Option>
                                                ))
                                            }
                                        </Select>:<Input style={{width: 200}} className="editGrade" autoComplete={"off"} placeholder="请输入年级" readOnly/>
                                    )}
                                </Form.Item>
                                <Form.Item label='班级名称'>
                                    {getFieldDecorator('name', {
                                        rules: [{required: true, message: '请输入班级名称!'}],
                                        initialValue: this.state.aClass.name
                                    })(
                                        <Input className='input' placeholder='请输入班级名称' style={{width: 200}}/>,
                                    )}
                                </Form.Item>
                            </Form>
                        </Modal>
                        <Modal
                            title="提示"
                            visible={setVisible}
                            okText={"确定"}
                            cancelText={"取消"}
                            onOk={this.setClass.bind(this, setRecord)}
                            onCancel={this.handleCancel}>
                            <div>确认修改{setRecord.name}的状态吗？</div>
                        </Modal>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}

const WrapGrade = Form.create()(Grade);
export default WrapGrade;